// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1RSj9","errors":"Errors_errors__BtpYd"};